import styled from 'styled-components';

export const Subtitle = styled.div`
    color: #6c757d;
    font-size: 14px;
    margin-top: 2px;
`

export const Section = styled.div`
    margin-top: 20px;

    &:first-child {
        margin-top: 0px;
    }
`

export const SectionTitle = styled.div`
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6c757d;
    margin-bottom: 8px;
`

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 8px;
`

export const InfoItem = styled.div<{ wide?: boolean }>`
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 8px 10px;
    grid-column: ${props => props.wide ? '1 / -1' : 'auto'};
`

export const InfoLabel = styled.div`
    font-size: 12px;
    color: #6c757d;
`

export const InfoValue = styled.div`
    font-weight: 600;
    word-break: break-word;
    white-space: pre-wrap;
`

export const EmptyValue = styled.span`
    color: #adb5bd;
    font-weight: normal;
`
